import { Alert, Box, Card, CircularProgress, Typography } from '@mui/material';
import React from 'react';

import { useApiData } from '../../hooks/useApiData';

const isForbidden = (err: Error | null) =>
  (err as any)?.response?.status === 403;

// The SwipeClock Web Clock supports `enclosed` and `compact` query params that strip the
// surrounding page chrome and render a tighter layout, which fits much better in a card.
// See https://developer.swipeclock.com/documentation/single-sign-on/embedded-wfh-employee-components/web-clock/
const toCompactClockUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('enclosed', '1');
    parsed.searchParams.set('compact', '1');
    return parsed.toString();
  } catch {
    return url;
  }
};

const ClockCard: React.FC = () => {
  const {
    data: clockUrl,
    error: clockError,
    loading: clockLoading,
  } = useApiData<string>((api) => api.attendance.getClockRedirect());

  if (!clockLoading && isForbidden(clockError)) {
    return null;
  }

  if (!clockLoading && (clockError || !clockUrl)) {
    return (
      <Alert severity="error">
        An error occured while loading the attendance page. Please refresh and
        try again
      </Alert>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: 3,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5">Time & attendance</Typography>
      </Box>
      {clockLoading ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        clockUrl && (
          <Box
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              border: '1px solid #f1f3f4',
              flexGrow: 1,
            }}
          >
            <iframe
              src={toCompactClockUrl(clockUrl)}
              title="SwipeClock"
              style={{
                width: '100%',
                height: '100%',
                minHeight: 320,
                border: 'none',
                display: 'block',
              }}
            />
          </Box>
        )
      )}
    </Card>
  );
};

export default ClockCard;
